// Tax ID regex patterns
// Accepted formats:
// - 12-3456789 or 12-3456789SW
// - 123-45-6789
// - 123456-78901
export const taxIDRegex = /^(?:\d{3}-\d{2}-\d{4}|\d{2}-\d{7}(?:[A-Za-z0-9]{2})?|\d{6}-\d{5})$/;

export const riNumberRegex = /^R\d{5}$/;
